// @flow
import moment from 'moment';

export default class HomeMeetingOwner {
  id: string;
  date_time: string;
  step: string;
  user: {
    id: string,
    email: string,
    name: string,
    last_name: string,
    second_last_name: string
  };
  created_by: {
    id: string,
    email: string,
    name: string,
    last_name: string,
    second_last_name: string
  };
  canceled_option: string;
  canceled_comment: string;
  why_not_attended: string;
  is_exclusive_kukulkan: boolean;
  pawahtun_home_meeting_id: string;
  end_date_time: string;
  full_date: {
    date: string,
    year: string,
    month: string,
    day: string,
    dayWeek: string,
    hours: string,
    minutes: string
  };

  constructor(data: any = {}) {
    moment.locale('es');
    let date = moment(data.date_time, 'YYYY-MM-DD HH:mm:ss');
    this.id = data.id;
    this.date_time = data.date_time;
    this.step = data.step;
    this.user = data.user;
    this.created_by = data.created_by;
    this.canceled_option = data.canceled_option;
    this.canceled_comment = data.canceled_comment;
    this.why_not_attended = data.why_not_attended;
    this.is_exclusive_kukulkan = data.is_exclusive_kukulkan;
    this.pawahtun_home_meeting_id = data.pawahtun_home_meeting_id;
    this.date_time_end = data.date_time_end;
    this.full_date = {
      date: date.format('YYYY/MM/DD'),
      year: date.format('YYYY'),
      month: date.format('M'),
      day: date.format('D'),
      dayWeek: date.day(),
      hours: date.format('H'),
      minutes: date.format('mm')
    };
  }
}
